bcn.backings = (function () {

'use strict';

  function grid () {
    var $grid = $('.js-activity-list').isotope({
      itemSelector: '.activity-card',
      percentPosition: true
    });

    $grid.imagesLoaded().progress( function() {
      $grid.isotope('layout');
    });
  }

  function loadMore () {
    $('a.js-load-activity-items').on('click', function (e) {
      e.preventDefault();

      $('.js-load-activity-items').hide();
      $('.js-loading-container').show();

      var offset = $(this).data('offset') || 0;

      $.ajax({
        type: 'GET',
        url: $(this).attr('href'),
        data: {
          tab: $(this).data('tab'),
          offset: offset
        },
        dataType: 'script',

        success: function () {
          $('.js-loading-container').hide();
          bcn.readMore.reload();
          grid();
        }
      });
    });
  }

  function initTabs () {
    $('.js_tab_link').on('click', function (e) {
      e.preventDefault();
      $('[data-tab]').removeClass('active');
      $(this).addClass('active');
      $('.js-no-backings').addClass('hidden').attr('aria-hidden', true);
      $('.js-load-activity-items').hide();
      $('.js-loading-container').show();

      $.ajax({
        type: 'GET',
        url: $(this).attr('href'),
        data: {
          tab: $(this).attr('data-tab')
        },
        dataType: 'script',

        success: function () {
          $('.js-loading-container').hide();
          bcn.readMore.reload();
          grid();
        }
      });
    });
  }

  function previewUpload () {
    $('#backing_image, #bcn_update_image').on('change', function(){
      bcn.imageUploadPreview.previewImage(this);
      $('.photo-upload').addClass('uploaded');
      $(this).parent()
        .append('<div class="photo-upload__uploaded-info"><p class="photo-upload__message">Photo uploaded</p><button type="button" class="button-link photo-upload__remove" data-upload-remove>Remove this photo</button></div>');
      $('.photo-upload__preview-image').show();
    });
  }

  function activityItemDelete() {
    $('.js-activity-list').on('ajax:success', '.activity-card [data-remote="true"]', function(){
      $(this).closest('.activity-card').fadeOut();
    });
  }

  return {
    init: function () {
      loadMore();
      grid();
      previewUpload();
      activityItemDelete();
      initTabs();
    },
    refresh: function () {
      grid();
    }
  };

})();
